module.exports = {
    FixedAmount: require('./Strategy/FixedAmount'),
    PartialPercentage: require('./Strategy/PartialPercentage'),
    Percentage: require('./Strategy/Percentage'),
    PercentageNoStake: require('./Strategy/PercentageNoStake'),
    ReversePartialPercentage: require('./Strategy/ReversePartialPercentage'),
    ReversePercentage: require('./Strategy/ReversePercentage'),
    ReversePercentageNoStake: require('./Strategy/ReversePercentageNoStake')
};